import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import Recaptcha from "../recaptcha/Recaptcha";
import Autocomplete from "../autocomplete/Autocomplete";
import { trackEvent } from "../cookieConsent/CookieConsent";

import config from "../../config";
import styles from "./QuoteForm.module.css"
import translations from "./quote-form-translations";
import {
  toInt,
  TimeInput,
  CalendarIcon,
  ClockIcon,
  UserIcon,
  BagIcon,
  CheckIcon,
  PhoneIcon,
  VehicleIcon,
  Stepper,
} from "./QuoteFormParts";

const QuoteForm = (props) => {

    const navigate = useNavigate();

    const date = new Date();
    const year = date.getFullYear();
    const month = (date.getMonth()<9 ? "0"+(date.getMonth()+1) : date.getMonth()+1);
    const day = (date.getDate()<10 ? "0"+date.getDate() : date.getDate());
    const today = year+"-"+month+"-"+day;

    const [quote, setQuote] = useState({
        voyage: translations[props.lang].voyage.options[0].value,
        passenger: "1",
        bagages: "0",
        vehicule: ['berline','van','minibus'].includes(props.vehicule) ? props.vehicule : 'van',
        date: today,
        hour: "10",
        minute: "00",
        return_date: today,
        return_hour: "11",
        return_minute: "00"
    });
  
    const handleChange = (event) => {
      const name = event.target.name;
      const value = event.target.value;
      setQuote(values => ({...values, [name]: value}))
    }

    const setField = (name, value) => {
      setQuote(values => ({...values, [name]: value}))
    }

    const allowedFields = [
      "address_depart",
      "address_depart_number",
      "address_depart_city",
      "address_depart_address",
      "address_depart_cp",
      "address_depart_country",
      "address_depart_lng",
      "address_depart_lat",
      "address_arrive",
      "address_arrive_number",
      "address_arrive_city",
      "address_arrive_address",
      "address_arrive_cp",
      "address_arrive_country",
      "address_arrive_lng",
      "address_arrive_lat",
      "voyage",
      "date",
      "hour",
      "minute",
      "return_date",
      "return_hour",
      "return_minute",
      "vehicule",
      "passenger",
      "bagages",
      "firstname",
      "lastname",
      "email",
      "phone",
      "g-recaptcha-response",
    ];
    const intFields = ["passenger", "bagages"];
    const floatFields = [
      "address_depart_lng",
      "address_depart_lat",
      "address_arrive_lng",
      "address_arrive_lat",
    ];
    const cleaning = () => {
      if (quote.voyage === "simple") {
        delete quote.return_date;
        delete quote.return_hour;
        delete quote.return_minute;
      }
      for (var a in quote) {
        if (!allowedFields.includes(a)) {
          delete quote[a];
        } else if (intFields.includes(a)) {
          quote[a] = isNaN(parseInt(quote[a])) ? parseInt(quote[a]) : quote[a];
        } else if (floatFields.includes(a)) {
          quote[a] = isNaN(parseInt(quote[a])) ? parseFloat(quote[a]) : quote[a];
        } else if (typeof quote[a] != "string" || quote[a] === "" || quote[a] === null) {
          delete quote[a];
        }
      }
    }

    const switchSubmitButton = () => {
      document.getElementById('submit').disabled = !document.getElementById('submit').disabled;
    }

    const handleSubmit = (event) => {
      event.preventDefault();

      switchSubmitButton();
      
      cleaning();

      axios
      .post(config["api-endpoint"] + "/quotes/", quote, {
        headers: {
          "x-api-key": config['x-api-key'],
        },
      })
      .then((res) => {
        if(res.status===404){
          navigate((props.lang==='fr'?'':'/'+props.lang));
        }
        if(res.status===200){
          trackEvent("generate_lead");
          navigate(
            (props.lang==='fr'?'':'/'+props.lang)+"/devis-reservation-vtc/confirmation",
            {
              state : quote,
              replace:true
            }
          );
        }
        if(res.status===400){
          if(res.data.error==='Recaptcha Error'){
            document.getElementById('FormError').innerHTML = translations[props.lang].error.recaptcha;
          } else if (res.data.error ==='Quote Not Inserted'){
            document.getElementById('FormError').innerHTML = translations[props.lang].error.form;
          }
          switchSubmitButton();
        }
      })
      .catch((error) => {
        document.getElementById('FormError').innerHTML = translations[props.lang].error.form;
        switchSubmitButton();
      })
    }
  
    const setMyToken = (token) => {
      quote['g-recaptcha-response']=token;
    }

    var mapping = {
      depart: {
        formatted_address: "address_depart",
        street_number: "address_depart_number",
        route: "address_depart_address",
        locality: "address_depart_city",
        country: "address_depart_country",
        postal_code: "address_depart_cp",
        lat: "address_depart_lat",
        lng: "address_depart_lng",
      },
      arrive: {
        formatted_address: "address_arrive",
        street_number: "address_arrive_number",
        route: "address_arrive_address",
        locality: "address_arrive_city",
        country: "address_arrive_country",
        postal_code: "address_arrive_cp",
        lat: "address_arrive_lat",
        lng: "address_arrive_lng",
      },
    };

    const setAddress = (autocomplete, direction) => {
      var place = autocomplete.getPlace();
      quote['address_'+direction+'_lng'] = place.geometry.location.lng();
      quote['address_'+direction+'_lat'] = place.geometry.location.lat();
      for (let i = 0; i < place.address_components.length; i++) {
        let addressType = place.address_components[i].types[0];
        quote[mapping[direction][addressType]] = place.address_components[i].long_name;
      }
      quote[mapping[direction]['formatted_address']] = place.formatted_address;
    }

    const addressSuffixes = ["", "_number", "_address", "_city", "_country", "_cp", "_lat", "_lng"];

    const swapAddresses = () => {
      const from = document.getElementById("address-depart");
      const to = document.getElementById("address-arrive");
      if (from && to) {
        const text = from.value;
        from.value = to.value;
        to.value = text;
      }
      setQuote((values) => {
        const next = { ...values };
        addressSuffixes.forEach((suffix) => {
          const fromKey = "address_depart" + suffix;
          const toKey = "address_arrive" + suffix;
          const fromValue = values[fromKey];
          const toValue = values[toKey];
          if (toValue === undefined) { delete next[fromKey]; } else { next[fromKey] = toValue; }
          if (fromValue === undefined) { delete next[toKey]; } else { next[toKey] = fromValue; }
        });
        return next;
      });
    };

  const t = translations[props.lang];

  const timePills = (prefix, dateLabel, hourLabel, minuteLabel) => {
    const dateKey = prefix ? prefix + "_date" : "date";
    const hourKey = prefix ? prefix + "_hour" : "hour";
    const minuteKey = prefix ? prefix + "_minute" : "minute";
    return (
      <div className="pill-row">
        <div className="pill-field">
          <CalendarIcon />
          <div className="pill-body">
            <label htmlFor={dateKey}>{dateLabel}</label>
            <input
              type="date"
              name={dateKey}
              min={today}
              id={dateKey}
              required
              value={quote[dateKey] || ""}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="pill-field">
          <ClockIcon />
          <div className="pill-body">
            <label htmlFor={hourKey}>{hourLabel}</label>
            <TimeInput
              hourName={hourKey}
              minuteName={minuteKey}
              hourValue={quote[hourKey]}
              minuteValue={quote[minuteKey]}
              minuteLabel={minuteLabel}
              onCommit={setField}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="pricing quote-form-shell">
            <form className="needs-validation" onSubmit={handleSubmit}>
              <Autocomplete lang={props.lang} setAddress={setAddress} onSwap={swapAddresses}/>

              <div className="seg" role="group" aria-label={t.voyageGroup}>
                {t.voyage.options.map((option) => (
                  <button
                    type="button"
                    key={option.value}
                    className={"seg-btn" + (quote.voyage === option.value ? " is-on" : "")}
                    aria-pressed={quote.voyage === option.value}
                    onClick={() => setField("voyage", option.value)}
                  >
                    {option.label}
                  </button>
                ))}
              </div>

              {timePills("", t.startDate.label, t.startHour.label, t.startMin.label)}

              {quote.voyage === 'return' &&
                <div id="return-row">
                  {timePills("return", t.toDate.label, t.toHour.label, t.toMin.label)}
                </div>
              }

              <div className="step-card">
                <Stepper
                  icon={<UserIcon />}
                  label={t.passengersLabel}
                  value={toInt(quote.passenger, 1, 1, 20)}
                  min={1}
                  max={20}
                  lessLabel={t.passengerLess}
                  moreLabel={t.passengerMore}
                  onChange={(n) => setField("passenger", String(n))}
                />
                <Stepper
                  icon={<BagIcon />}
                  label={t.bagagesLabelStepper}
                  value={toInt(quote.bagages, 0, 0, 20)}
                  min={0}
                  max={20}
                  lessLabel={t.bagageLess}
                  moreLabel={t.bagageMore}
                  onChange={(n) => setField("bagages", String(n))}
                />
              </div>

              <div className="veh-grid" role="group" aria-label={t.vehiculeGroup}>
                {t.vehicule.cards.map((card) => {
                  const on = quote.vehicule === card.value;
                  return (
                    <button
                      type="button"
                      key={card.value}
                      className={"veh-card" + (on ? " is-on" : "")}
                      aria-pressed={on}
                      onClick={() => setField("vehicule", card.value)}
                    >
                      <VehicleIcon type={card.value} />
                      <span className="veh-text">
                        <span className="veh-name">{card.name}</span>
                        <span className="veh-seats">{card.seats}</span>
                      </span>
                      <span className="veh-check" aria-hidden="true">{on ? <CheckIcon /> : null}</span>
                    </button>
                  );
                })}
              </div>

              <h2 className="contact-title">{t.contactTitle}</h2>
              <div className="contact-grid">
                <div className="cell-field">
                  <label htmlFor="firstname">{t.firstname.label}</label>
                  <input
                    type="text"
                    id="firstname"
                    name="firstname"
                    required
                    autoComplete="given-name"
                    value={quote.firstname || ""}
                    onChange={handleChange}
                  />
                </div>
                <div className="cell-field">
                  <label htmlFor="lastname">{t.lastname.label}</label>
                  <input
                    type="text"
                    id="lastname"
                    name="lastname"
                    required
                    autoComplete="family-name"
                    value={quote.lastname || ""}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="cell-field">
                <label htmlFor="email">{t.email.label}</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  autoComplete="email"
                  placeholder="name@example.com"
                  value={quote.email || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="cell-field">
                <label htmlFor="phone">{t.phone.label}</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  autoComplete="tel"
                  placeholder="+33 6 12 34 56 78"
                  value={quote.phone || ""}
                  onChange={handleChange}
                />
              </div>

              <p id="FormError" className={styles.error}></p>
              <div className="quote-actions">
                <a className="quote-call" href="tel:+33660265336" aria-label={t.call}>
                  <PhoneIcon />
                </a>
                <button className="btn btn-primary" id="submit">
                  {t.submit.label}
                </button>
              </div>
            </form>
        <Recaptcha setToken={setMyToken} lang={props.lang}/>
    </div>
  );
};

export default QuoteForm;
